import { privacyPolicies } from "@app/constants/policies";
import PrivacyPolicySectionContentComponent from "./content-component";

const PrivacyPolicySectionContent = () => {
  return (
    <div className="flex flex-col gap-y-6 md:gap-y-12 md:max-w-[720px]">
      {privacyPolicies.map((policy, i) => (
        <PrivacyPolicySectionContentComponent
          key={i}
          policy={policy}
        />
      ))}
    </div>
  );
};

export default PrivacyPolicySectionContent;
